import styled from 'styled-components';
import '../Button/index.js';
import { Button } from '../Button/Button.js';

const ButtonPill = styled(Button) `
  height: 40px;
  border-radius: 999px;
  padding-right: 4px;
  padding-left: 16px;
`;
const AvatarWrapper = styled.div `
  margin-left: 12px;
`;
const WorkspaceName = styled.span `
  font-size: 1rem;
  line-height: 1.4;
`;

export { AvatarWrapper, ButtonPill, WorkspaceName };
